module.exports = __webpack_public_path__ + "img/报表平台.9597bc57.svg";